import { useTranslation } from 'react-i18next';

import { Button } from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import type { DigitallyReceivedPrescriberOrderInfoFragment } from '../../../graphql/generated/graphql';

import { SwitchOtherOptionsModal } from './SwitchOtherOptionsModal';

export type SwitchOtherOptionsProps = {
    order: DigitallyReceivedPrescriberOrderInfoFragment;
};

export const SwitchOtherOptions = ({ order }: SwitchOtherOptionsProps) => {
    const { t } = useTranslation();
    const [isOpen, { toggle }] = useDisclosure(false);

    return (
        <>
            <Button onClick={toggle} variant="subtle">
                {t('otherOptions.button.expectingSomethingElse')}
            </Button>
            <SwitchOtherOptionsModal
                isOpen={isOpen}
                order={order}
                toggle={toggle}
            />
        </>
    );
};
